var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBootcampjscalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    rx: 10,
    fill: "#FBBF30",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0mzlntevha)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#s6mipyz26b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.537 21.723c.819-.595 1.805-.903 3.15-1.062v1.12a1.938 1.938 0 0 0 3.875 0v-1.288c.6-.003 1.244-.003 1.938-.003s1.338 0 1.938.003v1.288a1.938 1.938 0 0 0 3.874 0v-1.12c1.346.16 2.332.467 3.15 1.062a6.46 6.46 0 0 1 1.43 1.429c.728 1.003 1.027 2.26 1.149 4.119H18.959c.122-1.86.42-3.116 1.15-4.12a6.46 6.46 0 0 1 1.428-1.428z",
    fill: "#FBBF30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.889 29.208c-.014.86-.014 1.823-.014 2.907 0 4.843 0 7.265 1.233 8.962.399.549.88 1.03 1.43 1.43 1.697 1.233 4.119 1.233 8.962 1.233 1.084 0 2.046 0 2.906-.014v-.09c0-1.101 0-1.772.092-2.35a7.427 7.427 0 0 1 6.174-6.174c.578-.091 1.248-.091 2.349-.091h.09c.014-.86.014-1.823.014-2.906 0-1.084 0-2.047-.014-2.907H18.89z",
    fill: "#FBBF30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.463 42.506c-1.004.73-2.26 1.027-4.12 1.15 0-1.177.005-1.669.068-2.067a5.49 5.49 0 0 1 4.564-4.563c.398-.063.89-.068 2.066-.068-.122 1.86-.42 3.116-1.15 4.12a6.462 6.462 0 0 1-1.428 1.428zM27.594 17.906a.969.969 0 0 0-1.938 0v3.875a.969.969 0 0 0 1.938 0v-3.875zM35.344 17.906a.969.969 0 0 0-1.938 0v3.875a.969.969 0 0 0 1.938 0v-3.875z",
    fill: "#FBBF30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.156 20.102-.527.062c-1.39.165-2.471.49-3.386 1.154a6.96 6.96 0 0 0-1.54 1.54c-.813 1.12-1.119 2.493-1.242 4.38l-.035.533h24.149l-.036-.533c-.123-1.887-.43-3.26-1.243-4.38a6.96 6.96 0 0 0-1.54-1.54c-.914-.664-1.995-.989-3.385-1.154l-.527-.062v-2.196a1.469 1.469 0 1 0-2.938 0v2.09l-.465-.003c-.601-.003-1.247-.003-1.94-.003H30.5c-.693 0-1.339 0-1.94.003l-.465.003v-2.09a1.469 1.469 0 1 0-2.938 0v2.196zm-6.261 8.606-.498-.006-.008.498c-.014.864-.014 1.83-.014 2.912v.033c0 2.396 0 4.234.157 5.684.159 1.466.483 2.594 1.172 3.542l.4-.29-.4.29c.43.591.949 1.11 1.54 1.54.948.689 2.076 1.013 3.541 1.172 1.45.157 3.288.157 5.684.157h.033c1.082 0 2.048 0 2.912-.014l.492-.008v-.582c0-1.117.002-1.741.086-2.272a6.927 6.927 0 0 1 5.758-5.758c.53-.084 1.154-.085 2.27-.085h.583l.008-.492c.014-.864.014-1.83.014-2.911v-.006c0-1.082 0-2.048-.014-2.912l-.008-.498-.498.006h-23.21zm15.949 14.947v.534l.532-.035c1.888-.124 3.26-.43 4.38-1.243a6.96 6.96 0 0 0 1.54-1.54c.814-1.12 1.12-2.493 1.243-4.38l.035-.533h-.533c-1.158 0-1.698.003-2.145.074a5.99 5.99 0 0 0-4.979 4.979c-.07.447-.073.987-.073 2.144z",
    stroke: "url(#74hcpem06c)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#s80hz4k25d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.625 32.438a.969.969 0 0 0 0 1.937h7.75a.969.969 0 1 0 0-1.938h-7.75z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "s6mipyz26b",
    x: -6.125,
    y: -8.063,
    width: 73.25,
    height: 76.802,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_402_2488"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_402_2488",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s80hz4k25d",
    x: 22.656,
    y: 29.438,
    width: 25.688,
    height: 17.938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_2488"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_2488",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "74hcpem06c",
    x1: 18.875,
    y1: 16.938,
    x2: 45.418,
    y2: 39.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0mzlntevha"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(15 15)",
    d: "M0 0h31v31H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootcampjscalendar);
export default __webpack_public_path__ + "static/media/Bootcamp js calendar.0b2d34e80bf0a0169e462f585ab4fbf0.svg";
export { ForwardRef as ReactComponent };